<p-popover
  #popover
  [baseZIndex]="baseZIndex"
  [styleClass]="customClass"
  [dismissable]="dismissable"
  [appendTo]="appendTo"
  (onShow)="panelShow.emit($event)"
  (onHide)="panelHide.emit($event)">
  <ng-content></ng-content>
</p-popover>
